module.exports = __webpack_public_path__ + "resources/img/img_intro_certi3.f9b434f25323ddd92fcf0df282d57f5e.png";